import { Component, Input, OnInit } from '@angular/core';
import { AuctionDetailButtonConfiguration } from './auction-detail-button.configuration';

@Component({
  selector: 'auction-detail-button',
  templateUrl: './auction-detail-button.component.html',
  styleUrls: ['./auction-detail-button.component.scss']
})
export class AuctionDetailButtonComponent implements OnInit {

  @Input() configuration : AuctionDetailButtonConfiguration;

  constructor() { }

  ngOnInit() {
  }

}
